import { render, staticRenderFns } from "./ImportGoods.vue?vue&type=template&id=531989c8&"
import script from "./ImportGoods.vue?vue&type=script&lang=js&"
export * from "./ImportGoods.vue?vue&type=script&lang=js&"
import style0 from "./ImportGoods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports